var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDoctorCertificate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "doctor (2) 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M12.9894 4.98514V2.99505C12.9894 2.4455 12.5433 2 11.993 2H8.00704C7.4567 2 7.01056 2.4455 7.01056 2.99505V4.98514M10 9.46285V11.4529M10 11.4529V13.443M10 11.4529H11.993M10 11.4529H8.00704M2.91003 16.611C1.69666 13.279 1.69666 9.62687 2.91003 6.29491C2.98202 6.09722 3.14455 5.94598 3.3471 5.88819L3.70365 5.78646C7.81888 4.61238 12.1811 4.61238 16.2963 5.78646L16.6529 5.88819C16.8555 5.94598 17.018 6.09722 17.09 6.29491C18.3033 9.62687 18.3033 13.279 17.09 16.611C17.018 16.8087 16.8555 16.9599 16.6529 17.0177L16.2963 17.1194C12.1811 18.2935 7.81888 18.2935 3.70365 17.1194L3.3471 17.0177C3.14455 16.9599 2.98202 16.8087 2.91003 16.611Z",
    stroke: "#657397",
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDoctorCertificate);
export default __webpack_public_path__ + "static/media/Icon_doctor_certificate.8b214bf20d59d3afb247df9e403a7c40.svg";
export { ForwardRef as ReactComponent };